import api from "./api";

export async function addSlide(documentId: string, slideIndex: string) {
  const addKbResponse = await api.post(
    `/slides/base?slide_index=${Number(slideIndex)}&document_id=${documentId}`
  );
  return addKbResponse.data;
}
